import { createContext, useContext } from 'react';
export const ProTableContext = /*#__PURE__*/createContext({});
ProTableContext.displayName = 'ProTableContext';
export const useProTableContext = () => useContext(ProTableContext);
//# sourceMappingURL=es/context.js.map